import React, { useEffect } from "react";
import Table from "./Table";

const UjiSilangKabKotaSlideNegatif = () => {
  useEffect(() => {
    document.title = "SISMAL | Uji Silang Kab/Kota";
  }, []);

  return (
    <div className="dashboard-wrapper">
      <Table />
    </div>
  );
};

export default UjiSilangKabKotaSlideNegatif;
